import { all, call, put, takeLatest } from "redux-saga/effects";

import { SCREEN } from "helper/roleChecker/Screens";
import {
  getAuthorizationDocsDetailFailed,
  getAuthorizationDocsDetailStart,
  getAuthorizationDocsDetailSuccess,
} from "../redux/getDetail";
import { getAuthorizationDocumentDetailAPI } from "core/http/service/authorizationDocument";

function* getDocsDetailWork(action) {
  const payload = action.payload;
  try {
    const res = yield call(getAuthorizationDocumentDetailAPI, {
      screenCode: SCREEN.IP_014,
      id: payload.id,
    });
    yield put({
      type: getAuthorizationDocsDetailSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getAuthorizationDocsDetailFailed.type,
    });
  }
}

function* watchGetDocsDetail() {
  yield takeLatest(getAuthorizationDocsDetailStart.type, getDocsDetailWork);
}

export default function* getNewsDetailSaga() {
  yield all([watchGetDocsDetail()]);
}
